export const systemDashboardIntroSteps = [
  {
    element: '.report-section-header',
    intro: 'The Teacher Dashboard is where you can view key overview data on student usage and progress.'
  },
  {
    element: 'refresh-button',
    intro: 'Click here to refresh the Dashboard data.'
  },
  {
    element: '#daily-notifications',
    intro: 'See a daily summary of recent notifications grouped by student celebrations and students who need attention. Click "Go to Notifications" for the full list.'
  },
  {
    element: '#weekly-reminders',
    intro: 'Quick weekly reminders to help you get the most out of WordFlight. Click "View Details" for more.'
  },
  {
    element: '#minutes-usage',
    intro: 'See how many of your students fall into each weekly usage range. Toggle between the current and previous week, and click "View List" to see the students in a range.'
  },
  {
    element: '#unit-placement',
    intro: 'See the number of students working in each unit, grouped by objective with the Pre, Mid, and Post diagnostic milestones.'
  },
];
